import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData } from "dto/IClient";
import PhoneIcon from "assets/icons/PhoneWhite.svg?react";
import EditIcon from "assets/icons/EditClient.svg?react";
import DeleteIcon from "assets/icons/deleteClient.svg?react";
import { useContext, useMemo } from "react";
import Button from "components/Button";
import ModalsManagerContext from "contexts/ModalsManager";
import ClientsContext from "contexts/ClientsContext";
import clientService from "api/clientService";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PersonClientButtons: FC<Props> = ({ client }) => {
  const { t } = useTranslation();
  const { modals, setModals } = useContext(ModalsManagerContext);
  const { clients, setClients } = useContext(ClientsContext);
  const { mutate: deleteClient } = clientService.useDeleteClient();
  const navigate = useNavigate();

  const emails = useMemo(
    () =>
      client?.Data?.filter(
        (d) => d.Type === EClientData.EMAIL && !!d.Value.length
      ) ?? [],
    [client.Data]
  );

  const phones = useMemo(
    () =>
      client?.Data?.filter(
        (d) => d.Type === EClientData.PHONE && !!d.Value.length
      ) ?? [],
    [client.Data]
  );

  console.log(phones);

  const handleDelete = () => {
    const newClients = [...clients].filter((c) => c.Id !== client.Id);
    setClients(newClients);
    navigate("/clients/all");
    deleteClient({
      Id: client.Id,
    });
  };

  const handleEdit = () => {
    setModals({ ...modals, createEntity: true, hide: false });
    localStorage.setItem("toEdit", JSON.stringify(client));
  };

  return (
    <div className={styles.wrapper}>
      <Button
        disabled={!emails.length}
        className={styles.btn}
        onClick={() => {
          sessionStorage.setItem(
            "sendTo",
            emails.find((e) => e.IsMain)?.Value ?? emails[0].Value
          );
          setModals({ ...modals, createPost: true, hide: false });
        }}
        text={t("clients.sendMessage")}
      />
      <div
        onClick={() => {
          const phone =
            client?.Data?.find((d) => d.Type === EClientData.PHONE && d.IsMain)
              ?.Value ?? null;
          if (!phone) return;
          window.parent.location.href = `tel:${phone}`;
        }}
        className={`${styles.add} ${styles.buttonAdd} ${
          !phones.length && styles.disabled
        }`}
      >
        <PhoneIcon />
      </div>
      <div className={styles.add} onClick={handleEdit}>
        <EditIcon />
      </div>
      <div onClick={handleDelete} className={styles.add}>
        <DeleteIcon />
      </div>
    </div>
  );
};

export default PersonClientButtons;
